
import CHeader from '@/components/Header'
import TransMap from '@/components/TransMap'
import Search from 'vux/src/components/search/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Timeline from 'vux/src/components/timeline/timeline.vue'
import TimelineItem from 'vux/src/components/timeline/timeline-item.vue'
import Popup from 'vux/src/components/popup/index.vue'

export default {
name: 'GoodsTracking',
components: {
CHeader,
TransMap,
Search,
Cell,
Group,
Timeline,
TimelineItem,
Popup
},
data () {
return {
ENGINE_NO: '',
color: 'red',
order: null,
mapShow: false,
mapParams: null,
flowPass: false
}
},
created () {
this.ENGINE_NO = this.$route.query.ENGINE_NO
if (this.ENGINE_NO) this.onSubmit()
},
methods: {
toGoodsMap () {
var mapParams = {
STATUS: this.order.STATUS,
TRUCK_GUID: this.order.GUID,
CODE_103: this.order.RDC,
CODE_102: this.order.RECEIVINGPLACE
}
this.$router.push({
path: './tracking_map?params=' + encodeURIComponent(JSON.stringify(mapParams))
})
},
onSubmit () {
let _this = this
if (!this.ENGINE_NO || this.ENGINE_NO.length < 8) {
_this.$toast.text('请录入运单号')
return
}
_this.$vux.loading.show()
let url = 'Truck.ashx?action=Form_Load'
this.$post(url, {
ENGINE_NO: this.ENGINE_NO
}, {
login: false
}).then(
response => {
_this.order = response[0]
_this.flowPass = [10, 11].indexOf(_this.order.STATUS) != -1
_this.$vux.loading.hide()
}
).catch(
response => {
_this.$vux.loading.hide()
}
)
}
}
}



// WEBPACK FOOTER //
// ./src/pages/ctd/GoodsTracking.vue